import { useColor, useIsMobileSize } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Pressed, Tooltip } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

const IconDownload = () => {
  const isMobile = useIsMobileSize();
  const color = useColor({
    dark: ColorsDark.white,
    light: ColorsLight.black,
  });
  return <Icon.Download color={color} size={isMobile ? 20 : 24} />;
};

const RenderDownload = ({ onDownload }: { onDownload: () => void }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('common.download')}>
      <Pressed onClick={onDownload}>
        <IconDownload />
      </Pressed>
    </Tooltip>
  );
};

export const renderDownload = (onDownload: () => void) => (
  <RenderDownload onDownload={onDownload} />
);
